// extracted by mini-css-extract-plugin
module.exports = {"loader":"global-loader_loader__V7hJz","spin":"global-loader_spin__Lp9HV"};